import Config from '@config';
import {
  GasDistributionStationInformation,
  useGasDistributionStationDetails,
} from '@gasbi/shared/web/Gds';
import { LocationMap, MapIconType } from '@gasbi/shared/web/components/Map';
import { formatSettlementLabel } from '@gasbi/shared/web/forms/AddressForm/SettlementOptionCard';

/** The ГРС card with its map, as in BMS: the marker at its coordinates and its ЄДРА settlement. */
const Information = () => {
  const { gdStation } = useGasDistributionStationDetails();
  const settlement = gdStation?.settlement;

  const position = {
    lng: Number(gdStation?.longitude),
    lat: Number(gdStation?.latitude),
  };

  return (
    <GasDistributionStationInformation
      map={
        <LocationMap
          apiKey={Config.VITE_GOOGLE_MAP_API_KEY}
          markers={[
            { type: MapIconType.GDS, title: gdStation?.name, position },
          ]}
          location={{
            // The ЄДРА registry settlement: its typed name with the region, and the full one with the district and community.
            addressLabel: settlement
              ? [
                  settlement.region,
                  formatSettlementLabel(
                    settlement.settlementType,
                    settlement.settlement,
                  ),
                ]
                  .filter(Boolean)
                  .join(', ')
              : '—',
            address: settlement?.fullAddress || '—',
            position,
          }}
        />
      }
    />
  );
};

export default Information;
